import { render, staticRenderFns } from "./InviteError.vue?vue&type=template&id=6cc4c7b8"
import script from "./InviteError.vue?vue&type=script&lang=js"
export * from "./InviteError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports